import DataExportModel from '../../models/DataDelivery/DataExportModel';
import {observable} from 'mobx'
import BaseStore from '../BaseStore';

class DataDeliveryStore extends BaseStore {

  exportLocationStore

  @observable protocolOptions = [{name: 'Disabled', id: -1}, {name: 'FTP', id: 1}, {name: 'File System', id: 2}, {name: 'HTTP', id: 3}];

  constructor(transportLayer) {
    super(DataExportModel, transportLayer);
  }
}

export default DataDeliveryStore;



// WEBPACK FOOTER //
// ./src/stores/DataDelivery/DataExportStore.js